import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import classes from "./EmailDisplay.module.css";
import minimizeWindowIcon from "../../../styling/preview/img/minimize-window.svg";
import maximizeWindowIcon from "../../../styling/preview/img/maximize-window.svg";
import closeWindowIcon from "../../../styling/preview/img/close-window.svg";
import { getInitials } from "../../../util/LearningPageHelpers";

interface Props {
    filledSenderAddress: string, 
    filledSubject: string, 
    filledBody: string,
    onClose?: () => void;
}

export const EmailDisplay = (props: Props) => {
    const { filledSenderAddress, filledSubject, filledBody, onClose } = props;
    const { t } = useTranslation();
    const mailBodyRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const disableLinks = () => {
            if (mailBodyRef.current) {
                const links = mailBodyRef.current.querySelectorAll('a');
                links.forEach(link => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    });
                });
            }
        };

        // Disable links after a short delay to ensure Froala has rendered
        const timeoutId = setTimeout(disableLinks, 100);
        
        // Also disable links when content changes
        disableLinks();

        return () => {
            clearTimeout(timeoutId);
        };
    }, [filledBody]);

    return (
        <div className={classes.emailDisplay}>
            <div className={`${classes.guideMail} guideMail`}>
                <div className={classes.mailHeaderBar}>
                  <div className={classes.mailHeaderBarIcon}>
                    <object type="image/svg+xml" data={minimizeWindowIcon} width="16" height="16" />
                  </div>
                  <div className={classes.mailHeaderBarIcon}>
                    <object type="image/svg+xml" data={maximizeWindowIcon} width="16" height="16" />
                  </div>
                  <div 
                    className={classes.mailHeaderBarIcon}
                    onClick={onClose}
                    style={{ cursor: onClose ? 'pointer' : 'default' }}
                  >
                    <object 
                      type="image/svg+xml" 
                      data={closeWindowIcon} 
                      width="16" 
                      height="16"
                      style={{ pointerEvents: 'none' }}
                      aria-label="Close window"
                    />
                  </div>
                </div>
                <div className={classes.mailHeaderInfo}>
                  <div className={classes.mailHeaderSubject}>
                    <span id="l_subject"><strong>{filledSubject}</strong> </span>
                  </div>
                  <div className={classes.senderReceiverContainer}>
                    <div className={classes.senderIcon}>{getInitials(filledSenderAddress)}</div>
                    <div>
                      <div className={classes.mailHeaderSender}>
                      <span id="l_sender"><strong>{filledSenderAddress}</strong> </span>
                    </div>
                    <div>
                      <strong>{t('emailPreview.to')}</strong> {t('emailPreview.yourEmailAddress')}
                    </div>
                    </div>
                    
                  </div>
                  
                </div>
                <div className={classes.mailBody} ref={mailBodyRef}>
                    <FroalaEditorView model={filledBody} />
                </div>
              </div>
            </div>
    )
}